import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const vendorRoutes: RouteConfig = {
  path: '/vendors',
  component: Layout,
  redirect: 'noRedirect', // '/vendors/list',
  name: 'Vendor',
  meta: {
    title: 'vendor',
    icon: 'people',
    roles: ['Admin']
  },

  children: [
    {
      path: 'vendorSearch',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/vendors/vendors2.vue'),
      name: 'Vendor Search',
      meta: {
        title: 'vendorSearch',
        icon: 'search',
        affix: false
      }
    },
    {
      path: 'create',
      component: () => import(/* webpackChunkName: "vendors-create" */ '@/views/vendors/create.vue'),
      name: 'CreateVendor',
      meta: {
        title: 'createVendor',
        icon: 'edit'
      }
    },
    {
      path: 'coverage/:id(\\d+)',
      component: () => import(/* webpackChunkName: "vendors-edit" */ '@/views/vendors/coverage.vue'),
      name: 'CoverageVendor',
      meta: {
        title: 'coverageVendor',
        noCache: true,
        activeMenu: '/vendors/list',
        hidden: true
      }
    },
    {
      path: 'edit/:id(\\d+)',
      component: () => import(/* webpackChunkName: "vendors-edit" */ '@/views/vendors/edit.vue'),
      name: 'EditVendor',
      meta: {
        title: 'editVendor',
        noCache: true,
        activeMenu: '/vendors/list',
        hidden: true
      }
    }
  ]
}

export default vendorRoutes
